export default {
  id: "inventory",
  name: "Inventory Item",
  settings: {}
};
